import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaCircle } from "react-icons/fa"; // Importing FontAwesome circle icon
import AdminDashboard from "../admindashboard";

function Reportspage() {
  const navigate = useNavigate();

  return (
    <div>
      <br/><br/><br/>
      <AdminDashboard />
      <div></div>
      <br />
      
      <div className="col-9 mx-xl-auto ps-xl-10">
        {/* Operational Report Card */}
        <div className="card card-raised mb-5">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              Appointment Report
            </div>
            <br />
            <div className="row">
              <div className="col-6 mb-3">
                <Link to="/users/viewReportsTrandsactionDateForAdmin" className="btn btn-link w-100">
                  <FaCircle className="me-2" size={8} /> By Transaction Date
                </Link>
              </div>
              <div className="col-6 mb-3">
                <Link to="/users/viewReportsByAdmin" className="btn btn-link w-100">
                  <FaCircle className="me-2" size={8} />  By Appointment Date
                </Link>
              </div>
            

            </div>
          </div>
        </div>

{/* <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
            Invoices Report
            </div>
            <br />
            <div className="row">
              <div className="col-6 mb-3">
              <Link to="/users/ExcemptedcustomerdeliveryReport" className="btn btn-link w-100">
          <FaCircle className="me-2" size={8} /> Incoming Invoices
        </Link>
              </div>
              <div className="col-6 mb-3">
              <Link to="/users/ExemptedcustomerpaymentReport" className="btn btn-link w-100">
          <FaCircle className="me-2" size={8} /> Outgoing Invoices
        </Link>
              </div>
         
            </div>
          </div>
        </div> */}


      </div>
    </div>
  );
}

export default Reportspage;
